/**
 * Feature param values for med plans. Used in the `feature` URL parameter
 * for clinical flow routing (e.g. insurance checker → clinical, paid campaigns).
 * Consumed by features.ts and planInformation recommendation logic.
 */
export const FEATURE_PARAM = {
  BRANDED: "branded",
  COMPOUNDED: "compounded",
  MICRODOSE: "microdose",
  MICRODOSE_PROACTIVE_HEALTH: "microdoseProactiveHealth",
  ORALS: "orals",
  TIRZEPATIDE: "tirzepatide",
  MICRODOSE_TIRZEPATIDE: "microdoseTirzepatide",
  ZEPBOUND_KWIKPEN: "zepbound",
  WEGOVY_PILL: "wegovy_pill",
  /** @deprecated Live campaigns still send `wegovypill`. New links use `WEGOVY_PILL`. */
  WEGOVY_PILL_DEPRECATED: "wegovypill",
  MICRODOSE_WEGOVY_PILL: "microdose_wegovy_pill",
  WEGOVY_PEN: "wegovyPen",
  FOUNDAYO: "foundayo",
} as const;
